

































































































































































































































































































































/** @format */

import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import OrganizationSearch from '@/components/organization-search/index.vue';
import * as _ from 'lodash';
import { ORDER_SPECIAL_RECORD } from '../../exception-management/router-names';
import { TRADE_RECORD_LIST, PARKING_RECORD_LIST } from '../../order-management/router-names';
import moment from 'moment';
import * as api from '../../../api/financial-management';
import { queryChannelList, carAbnormalLiftRate } from '../../../api/financial-management';
import ModalConfig from '@/components/modal-config/index.vue';
@Component({
  name: 'businessReport',
  components: {
    ParkingLotSearch,
    OrganizationSearch,
    ModalConfig
  }
})
export default class businessReport extends Mixins(TableMixin, TableWidthMixin) {
  // 仅车场视图
  parkViewOnly: boolean = false;
  // 视图类型
  viewType: number = 1;
  onViewTypeChange(e) {
    this.current = 1;
    this.total = 0;
    this.fetchTableData();
  }

  // 节点路径
  path: any[] = [];

  // 统计颗粒度
  reportType: string = '1';
  vehicleVisible: boolean = false;
  // 快捷时间范围按钮
  timeQuickSelect: any = {
    '1': [
      { value: 1, text: '昨天' },
      { value: 2, text: '本周' },
      { value: 3, text: '本月' },
      { value: -1, text: '自定义' }
    ],
    '2': [
      { value: 3, text: '本月' },
      { value: 4, text: '上月' },
      { value: 5, text: '近半年' },
      { value: -1, text: '自定义' }
    ],
    '3': [
      { value: 6, text: '本季度' },
      { value: 7, text: '上季度' },
      { value: 8, text: '本年' },
      { value: -1, text: '自定义' }
    ],
    '4': [{ value: 8, text: '本年度' }, { value: 9, text: '上年度' }, { value: -1, text: '自定义' }]
  };
  focusFlag: boolean = false;
  timeQuickButtons: any[] = this.timeQuickSelect[this.reportType];

  // 选择的时间范围
  timeRangeType: number = 2;

  // 自定义时间
  customTime: any[] = [];
  customTimeFormat: string = 'YYYY-MM-DD';
  customTimeMode: string[] = ['date', 'date'];
  endOpen: boolean = false;
  @Watch('reportType')
  onReportType() {
    // 变换快捷按钮
    this.timeQuickButtons = this.timeQuickSelect[this.reportType];

    if (this.reportType == '1') {
      this.customTimeMode = ['date', 'date'];
      this.customTimeFormat = 'YYYY-MM-DD';
      this.timeRangeType = this.timeQuickButtons[1].value;
    } else if (this.reportType == '2') {
      this.customTimeMode = ['month', 'month'];
      this.customTimeFormat = 'YYYY-MM';
      this.timeRangeType = this.timeQuickButtons[0].value;
    } else if (this.reportType == '4') {
      this.customTimeMode = ['year', 'year'];
      this.customTimeFormat = 'YYYY';
      this.timeRangeType = this.timeQuickButtons[0].value;
    }
    this.onTimeRangeTypeChange();
  }
  carAbnormalLiftList: any[] = [];
  handleOpenChange(status) {
    this.endOpen = true;
  }
  onCustomTimeChange(date: any, dateString: any) {
    if (date.length < 1) {
      this.filterParam.startTime = '';
      this.filterParam.endTime = '';
      return;
    }
    // 自定义，清空快捷按钮
    let [startTime, endTime] = date;
    if (this.reportType == '1') {
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
      this.endOpen = false;
    } else if (this.reportType == '2') {
      this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
    } else if (this.reportType == '3') {
      this.filterParam.startTime = startTime.startOf('quarter').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('quarter').format('YYYY-MM');
    } else if (this.reportType == '4') {
      this.filterParam.startTime = startTime.startOf('year').format('YYYY');
      this.filterParam.endTime = endTime.endOf('year').format('YYYY');
    }
  }
  onCustomTimeChange2(date: any, dateString: any) {
    if (date.length < 1) {
      this.filterParam.startTime = '';
      this.filterParam.endTime = '';
      return;
    }
    console.log(date);
    // 自定义
    let [startTime, endTime] = date;
    this.customTime = [startTime, endTime];
    if (this.reportType == '1') {
      this.filterParam.startTime = startTime.startOf('day').format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.endOf('day').format('YYYY-MM-DD');
    } else if (this.reportType == '2') {
      this.filterParam.startTime = startTime.startOf('month').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('month').format('YYYY-MM');
      this.endOpen = false;
    } else if (this.reportType == '3') {
      this.filterParam.startTime = startTime.startOf('quarter').format('YYYY-MM');
      this.filterParam.endTime = endTime.endOf('quarter').format('YYYY-MM');
      this.endOpen = false;
    } else if (this.reportType == '4') {
      this.filterParam.startTime = startTime.startOf('year').format('YYYY');
      this.filterParam.endTime = endTime.endOf('year').format('YYYY');
      this.endOpen = false;
    }
  }

  calcTime() {
    let startTime, endTime;
    switch (this.timeRangeType) {
      case 1:
        // 昨天
        startTime = moment()
          .subtract(1, 'd')
          .startOf('d');
        endTime = moment()
          .subtract(1, 'd')
          .endOf('d');
        break;
      case 2:
        // 本周
        startTime = moment().startOf('week');
        endTime = moment().endOf('week');
        break;
      case 3:
        // 本月
        startTime = moment().startOf('month');
        endTime = moment().endOf('month');
        break;
      case 4:
        // 上月
        startTime = moment()
          .startOf('month')
          .subtract(1, 'month');
        endTime = moment()
          .endOf('month')
          .subtract(1, 'month');
        break;
      case 5:
        // 近半年
        startTime = moment()
          .startOf('month')
          .subtract(5, 'month');
        endTime = moment().endOf('month');
        break;
      case 6:
        // 本季度
        startTime = moment().startOf('quarter');
        endTime = moment().endOf('quarter');
        break;
      case 7:
        // 上季度
        startTime = moment()
          .startOf('quarter')
          .subtract(1, 'quarter');
        endTime = moment()
          .endOf('quarter')
          .subtract(1, 'quarter');
        break;
      case 8:
        // 本年
        startTime = moment().startOf('year');
        endTime = moment().endOf('year');
        break;
      case 9:
        // 上年年
        startTime = moment()
          .startOf('year')
          .subtract(1, 'year');
        endTime = moment()
          .endOf('year')
          .subtract(1, 'year');
        break;
      default:
        startTime = moment().startOf('day');
        endTime = moment().endOf('day');
    }

    if (this.reportType == '1') {
      this.filterParam.startTime = startTime.format('YYYY-MM-DD');
      this.filterParam.endTime = endTime.format('YYYY-MM-DD');
    } else if (this.reportType == '2') {
      this.filterParam.startTime = startTime.format('YYYY-MM');
      this.filterParam.endTime = endTime.format('YYYY-MM');
      // } else if (this.reportType == '3') {
    } else if (this.reportType == '4') {
      this.filterParam.startTime = startTime.format('YYYY');
      this.filterParam.endTime = endTime.format('YYYY');
    }
  }

  onTimeRangeTypeChange() {
    this.current = 1;
    // 快捷按钮，计算时间范围
    if (this.timeRangeType !== -1) {
      this.customTime = [];
      this.calcTime();
      this.fetchTableData();
    }
  }

  // 机构树
  @Getter('organizations/getUserOrgTree')
  getUserOrgTree!: any[];
  // 要查看的机构
  selectOrgId: string = '';

  onSelectOrgIdChange() {
    let org = this.findOrg(this.selectOrgId, this.getUserOrgTree);
    if (!org) {
      return;
    }
    this.childrenOrgList = org.children ? org.children.filter(i => i.type == 'org') : [];
    this.selectChildOrgList = [];
    this.fetchTableData();
  }

  // 机构下拉列表
  childrenOrgList: any[] = [];
  // 选择的机构
  selectChildOrgList: any[] = [];

  // @Watch('selectChildOrgList')
  // onSelectChildOrgListChange() {
  //   this.filterParam.nodeIdList = this.getNodeIdList()
  // }

  // 选择的车场
  selectParkIdList: any[] = [];

  // @Watch('selectParkIdList')
  // onSelectParkIdListChange() {
  //   this.filterParam.nodeIdList = this.getNodeIdList()
  // }

  getNodeIdList() {
    if (this.viewType === 1) {
      return this.selectChildOrgList.length ? this.selectChildOrgList : this.childrenOrgList.map(i => i.id);
    } else {
      return this.selectParkIdList.length ? this.selectParkIdList : this.parkList.map(i => i.id);
    }
  }

  public filterParam: any = {
    nodeIdList: [],
    parkStatusList: [],
    startTime: '',
    endTime: '',
    propertyCarAmountOrderBy: '',
    monthCarAmountOrderBy: '',
    temporaryAmountOrderBy: '',
    electronicPaymentRateOrderBy: '',
    enterNumOrderBy: '',
    exitNumOrderBy: '',
    utilizationRateOrderBy: '',
    turnoverRateOrderBy: '',
    expectionRateOrderBy: '',
    abnormalLiftRateOrderBy: '',
    specialRecordsOrderBy: '',
    handRecordsOrderBy: '',
    reviseRecordsOrderBy: '',
    cleanRecordsOrderBy: '',
    specialFreeOrderBy: '',
    unpayOrderBy: '',
    temporaryUncollectedRateOrderBy: ''
  };
  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;
  channelLoading: boolean = false;
  parkName: any = '';
  clear() {
    this.filterParam.parkStatusList = [];
    this.current = 1;
    this.reportType = '1';
    this.timeRangeType = 2;
    this.calcTime();
    if (this.viewType === 1) {
      this.selectChildOrgList = [];
    } else {
      this.selectParkIdList = [];
    }
    this.filterParam.nodeIdList = this.getNodeIdList();
    this.$nextTick(() => {
      this.fetchTableData();
    });
  }

  @Getter('organizations/getUserParkingList')
  parkList!: any[];

  // 初始化加载，确保机构树有值
  init() {
    if (this.getUserOrgTree && this.getUserOrgTree.length) {
      let root = this.getUserOrgTree[0];
      this.selectOrgId = root.id;
      this.childrenOrgList = root.children ? root.children.filter(i => i.type === 'org') : [];
      if (!this.childrenOrgList.length) {
        this.parkViewOnly = true;
        this.viewType = 2;
      }
    } else {
      return;
    }
    this.onTimeRangeTypeChange();
  }

  // 页面被刷新时候，created并没有加载完机构树，需要加载完后再进行初始化
  @Watch('parkList')
  onPageReload() {
    this.init();
  }

  private created() {
    this.init();
  }

  findOrg(id, list) {
    for (let org of list) {
      if (org.id === id) {
        return org;
      }
      if (org.children && org.children.length) {
        let result = this.findOrg(id, org.children);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  // 下钻
  jumpTo(record) {
    // 车场视图不下钻
    if (this.viewType === 2) {
      return;
    }
    let org = this.findOrg(record.nodeId, this.getUserOrgTree);
    if (!org) {
      return;
    }
    // 没子机构不下钻
    if (!org.children || !org.children.filter(i => i.type === 'org').length) {
      this.$message.info('没有下级机构');
      return;
    }
    // 添加节点
    this.path.push(org);
    // 清空机构下拉框
    this.childrenOrgList = org.children ? org.children.filter(i => i.type === 'org') : [];
    this.selectChildOrgList = [];
    // 重置参数
    this.filterParam.nodeIdList = this.getNodeIdList();
    this.fetchTableData();
  }
  // 返回
  backTo(item, index) {
    // 点当前节点不用再跳一遍
    if (index === this.path.length - 1) {
      return;
    }
    let org = this.path[index];
    // 移除节点
    this.path.splice(index + 1);
    // 清空机构下拉框
    this.childrenOrgList = org.children ? org.children.filter(i => i.type === 'org') : [];
    this.selectChildOrgList = [];
    // 重置参数
    this.filterParam.nodeIdList = this.getNodeIdList();
    this.fetchTableData();
  }

  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      let param = {
        ...this.filterParam,
        reportType: this.reportType,
        viewType: this.viewType,
        page: this.current,
        pageSize: this.pageSize
      };
      param.nodeIdList = this.getNodeIdList();

      const { status, msg, code, data } = await api.queryBusinessReport(param);
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
      await this.querySummary(param);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  public async querySummary(param) {
    const { status, msg, code, data } = await api.queryBusinessReportSummary(param);
    if (data === null || data === undefined) {
      return;
    }
    const {
      averageTurnoverRate,
      averageUtilizationRate,
      totalCleanRecords,
      totalEnterNum,
      totalExitNum,
      totalFollowRecords,
      totalHandRecords,
      totalRefuseNum,
      totalReviewedNum,
      totalReviseRecords,
      totalSpecialFree,
      totalSpecialRecords,
      totalUnpay,
      totalUnreviewNum,
      totalExpectionRate,
      totalPasscageWay,
      totalPropertyCarAmount,
      totalMonthCarAmount,
      totalTemporaryAmount,
      electronicPaymentRate,
      abnormalLiftRate,
      temporaryUncollectedRate
    } = data;
    let summaryData = {
      cleanRecords: totalCleanRecords,
      enterNum: totalEnterNum,
      exitNum: totalExitNum,
      followRecords: totalFollowRecords,
      handRecords: totalHandRecords,
      nodeName: '合计',
      refuseNum: totalRefuseNum,
      reportDay: '',
      reviewedNum: totalReviewedNum,
      reviseRecords: totalReviseRecords,
      specialFree: totalSpecialFree,
      specialRecords: totalSpecialRecords,
      turnoverRate: averageTurnoverRate,
      unpay: totalUnpay,
      unreviewNum: totalUnreviewNum,
      utilizationRate: averageUtilizationRate,
      expectionRate: totalExpectionRate,
      passageWayRate: totalPasscageWay,
      isTotal: true,
      propertyCarAmount: totalPropertyCarAmount,
      monthCarAmount: totalMonthCarAmount,
      temporaryAmount: totalTemporaryAmount,
      electronicPaymentRate: electronicPaymentRate,
      abnormalLiftRate: abnormalLiftRate,
      temporaryUncollectedRate: temporaryUncollectedRate
    };
    this.tableData.push(summaryData);
  }

  private async download() {
    try {
      let param = {
        ...this.filterParam,
        viewType: this.viewType,
        reportType: this.reportType
      };
      param.nodeIdList = this.getNodeIdList();
      await api.exportBusinessReport(param);
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('exportLocalcashExport', '导出失败');
    }
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  getPopupContainer() {
    return this.$refs.panel['$el'];
  }

  get orgColumns() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '机构名称',
        dataIndex: 'nodeName',
        width: 170,
        scopedSlots: { customRender: 'organName' }
      },
      {
        title: '时间',
        dataIndex: 'reportDay',
        width: 140
      },
      {
        title: '收入统计',
        children: [
          {
            title: '产权车位收入',
            dataIndex: 'propertyCarAmount',
            sortable: true,
            width: 140
          },
          {
            title: '长租车位收入',
            dataIndex: 'monthCarAmount',
            sortable: true,
            width: 140
          },
          {
            title: '临停收入',
            dataIndex: 'temporaryAmount',
            sortable: true,
            width: 140
          },
          {
            title: '临停电子支付占比',
            dataIndex: 'electronicPaymentRate',
            sortable: true,
            width: 160,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          }
        ]
      },
      {
        title: '流量统计',
        children: [
          {
            title: '进场车辆',
            dataIndex: 'enterNum',
            width: 140,
            customRender: this.numberRender,
            sortable: true
          },
          {
            title: '出场车辆',
            dataIndex: 'exitNum',
            width: 140,
            customRender: this.numberRender,
            sortable: true
          },
          {
            title: '车位利用率',
            dataIndex: 'utilizationRate',
            width: 140,
            sortable: true,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          },
          {
            title: '车位周转率',
            dataIndex: 'turnoverRate',
            width: 140,
            sortable: true,
            customRender: v => {
              return this.numberRender(v, 2);
            }
          }
          // {
          //   title: '通道识别率',
          //   dataIndex: 'passageWayRate',
          //   customRender: v => {
          //     return this.numberRender(v, 2) + '%'
          //   },
          // },
        ]
      },
      {
        title: '临停异常统计',
        children: [
          // {
          //   title: '异常通行率',
          //   dataIndex: 'expectionRate',
          //   width: 120,
          //   sortable: true,
          //   customRender: v => {
          //     return this.numberRender(v, 2) + '%';
          //   }
          // },
          // {
          //   title: '异常抬杆率',
          //   dataIndex: 'abnormalLiftRate',
          //   width: 120,
          //   sortable: true,
          //   customRender: v => {
          //     return this.numberRender(v, 2) + '%';
          //   }
          // },
          {
            title: '特殊放行',
            dataIndex: 'specialRecords',
            width: 120,
            sortable: true,
            customRender: this.numberRender
          },
          {
            title: '手动抬杆',
            dataIndex: 'handRecords',
            width: 120,
            sortable: true,
            customRender: this.numberRender
          },
          {
            title: '车牌修正',
            dataIndex: 'reviseRecords',
            width: 120,
            sortable: true,
            customRender: this.numberRender
          },
          {
            title: '僵尸车清理',
            dataIndex: 'cleanRecords',
            width: 120,
            sortable: true,
            customRender: this.numberRender
          },
          // todo 临时屏蔽
          // {
          //   title: '跟车出场',
          //   dataIndex: 'followRecords',
          //   customRender: this.numberRender,
          // },
          {
            title: '特殊减免金额',
            dataIndex: 'specialFree',
            width: 140,
            sortable: true,
            // customRender: v => this.numberRender(v, 2),
            scopedSlots: { customRender: 'specialFree' }
          },
          {
            title: '应收未收金额',
            dataIndex: 'unpay',
            width: 140,
            sortable: true,
            // customRender: v => this.numberRender(v, 2),
            scopedSlots: { customRender: 'unpay' }
          },
          {
            title: '临停未收占比',
            dataIndex: 'temporaryUncollectedRate',
            width: 140,
            sortable: true,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          }
          // {
          //   title: '审核通过',
          //   dataIndex: 'reviewedNum',
          //   customRender: this.numberRender,
          // },
          // {
          //   title: '审核未通过',
          //   dataIndex: 'refuseNum',
          //   customRender: this.numberRender,
          // },
          // {
          //   title: '未审核',
          //   dataIndex: 'unreviewNum',
          //   customRender: this.numberRender,
          // },
        ]
      }
    ];
  }

  get parkColumns() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      // {
      //   title: '车场名称',
      //   dataIndex: 'parkName',
      //   width: 140,
      //   scopedSlots: { customRender: 'text-ellipse-to-tip' },
      // },
      {
        title: '车场名称',
        dataIndex: 'nodeName',
        width: 170,
        scopedSlots: { customRender: 'organName' }
      },
      {
        title: '时间',
        dataIndex: 'reportDay',
        width: 140
      },
      {
        title: '收入统计',
        children: [
          {
            title: '产权车位收入',
            width: 140,
            dataIndex: 'propertyCarAmount'
          },
          {
            title: '长租车位收入',
            width: 140,
            dataIndex: 'monthCarAmount'
          },
          {
            title: '临停收入',
            width: 140,
            dataIndex: 'temporaryAmount'
          },
          {
            title: '临停总应收',
            width: 140,
            dataIndex: 'allTemporaryAmount'
          },
          {
            title: '临停电子支付占比',
            dataIndex: 'electronicPaymentRate',
            width: 140,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          }
        ]
      },
      {
        title: '流量统计',
        children: [
          {
            title: '进场车辆',
            dataIndex: 'enterNum',
            width: 140,
            customRender: this.numberRender
          },
          {
            title: '出场车辆',
            dataIndex: 'exitNum',
            width: 140,
            customRender: this.numberRender
          },
          {
            title: '车位利用率',
            dataIndex: 'utilizationRate',
            width: 140,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          },
          {
            title: '车位周转率',
            dataIndex: 'turnoverRate',
            width: 140,
            customRender: v => {
              return this.numberRender(v, 2);
            }
          },
          {
            title: '通道识别率',
            dataIndex: 'passageWayRate',
            width: 140,
            scopedSlots: { customRender: 'passageWayRate' }
          }
        ]
      },
      {
        title: '临停异常统计',
        children: [
          // {
          //   title: '异常通行率',
          //   dataIndex: 'expectionRate',
          //   width: 120,
          //   customRender: v => {
          //     return this.numberRender(v, 2) + '%';
          //   }
          // },
          // {
          //   title: '异常抬杆率',
          //   dataIndex: 'abnormalLiftRate',
          //   width: 120,
          //   customRender: v => {
          //     return this.numberRender(v, 2) + '%';
          //   }
          // },
          {
            title: '车场异常抬杆率',
            dataIndex: 'carAbnormalLiftRate',
            width: 140,
            scopedSlots: { customRender: 'carAbnormalLiftRate' }
          },
          {
            title: '特殊放行',
            dataIndex: 'specialRecords',
            width: 120,
            customRender: this.numberRender
          },
          {
            title: '手动抬杆',
            dataIndex: 'handRecords',
            width: 120,
            customRender: this.numberRender
          },
          {
            title: '车牌修正',
            dataIndex: 'reviseRecords',
            width: 120,
            customRender: this.numberRender
          },
          {
            title: '僵尸车清理',
            dataIndex: 'cleanRecords',
            width: 120,
            customRender: this.numberRender
          },
          {
            title: '特殊减免金额',
            dataIndex: 'specialFree',
            // customRender: v => this.numberRender(v, 2),
            width: 140,
            scopedSlots: { customRender: 'specialFree' }
          },
          {
            title: '应收未收金额',
            dataIndex: 'unpay',
            // customRender: v => this.numberRender(v, 2),
            width: 140,
            scopedSlots: { customRender: 'unpay' }
          },
          {
            title: '临停未收占比',
            dataIndex: 'temporaryUncollectedRate',
            width: 140,
            customRender: v => {
              return this.numberRender(v, 2) + '%';
            }
          }
        ]
      }
    ];
  }

  numberRender(value, fixed) {
    if (isNaN(value)) {
      return value;
    } else {
      let num = fixed ? value.toFixed(fixed) : parseFloat(value.toFixed(2)) + '';
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }
  toSplice(row) {
    let prod;
    if (this.viewType === 1) {
      prod = {
        orgId: row.nodeId,
        parkStatusList: this.filterParam.parkStatusList,
        reportType: this.reportType,
        reportStartDate: row.reportDay,
        reportEndDate: '',
        parkIds: null
      };
      if (prod.reportType === '2') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        // @ts-ignore
        console.log(b.slice(-2) - 1, b.slice(-2) - 1, b, '>>>>>>>>>>>');
        // debugger
        if (a === prod.reportStartDate) {
          console.log(a);
          prod.reportStartDate = prod.reportStartDate + '-01';
          prod.reportEndDate =
            // @ts-ignore
            a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;

          console.log(prod.reportStartDate, prod.reportEndDate, '////////////9999999000000');
          // debugger
        }
      }
      if (prod.reportType === '4') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        let c = prod.reportStartDate;
        prod.reportStartDate = prod.reportStartDate + '-01-01';
        prod.reportEndDate =
          // @ts-ignore
          a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;
      }
    }
    if (this.viewType === 2) {
      prod = {
        parkIds: row.nodeId,
        parkStatusList: this.filterParam.parkStatusList,
        reportType: this.reportType,
        reportStartDate: row.reportDay,
        reportEndDate: '',
        orgId: ''
      };
      if (prod.reportType === '2') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        // @ts-ignore
        console.log(b.slice(-2) - 1, b.slice(-2) - 1, b, '>>>>>>>>>>>');
        // debugger
        if (a === prod.reportStartDate) {
          console.log(a);
          prod.reportStartDate = prod.reportStartDate + '-01';
          prod.reportEndDate =
            // @ts-ignore
            a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;

          console.log(prod.reportStartDate, prod.reportEndDate, '////////////9999999000000');
          // debugger
        }
      }
      if (prod.reportType === '4') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        let c = prod.reportStartDate;
        prod.reportStartDate = prod.reportStartDate + '-01-01';
        prod.reportEndDate =
          // @ts-ignore
          a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;
      }
    }

    this.$router.push({
      name: ORDER_SPECIAL_RECORD,
      params: prod
    });
  }
  toDeal(row) {
    console.log(row);
    let prods;
    if (this.viewType === 1) {
      prods = {
        orgId: row.nodeId,
        parkStatusList: this.filterParam.parkStatusList,
        reportType: this.reportType,
        reportStartDate: row.reportDay,
        reportEndDate: '',
        parkIds: null
      };
      if (prods.reportType === '2') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        // @ts-ignore
        console.log(b.slice(-2) - 1, b.slice(-2) - 1, b, '>>>>>>>>>>>');
        // debugger
        if (a === prods.reportStartDate) {
          console.log(a);
          prods.reportStartDate = prods.reportStartDate + '-01';
          prods.reportEndDate =
            // @ts-ignore
            a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;

          console.log(prods.reportStartDate, prods.reportEndDate, '////////////9999999000000');
          // debugger
        }
      }
      if (prods.reportType === '4') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        let c = prods.reportStartDate;
        prods.reportStartDate = prods.reportStartDate + '-01-01';
        prods.reportEndDate =
          // @ts-ignore
          a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;
      }
    }
    if (this.viewType === 2) {
      prods = {
        parkIds: row.nodeId,
        parkStatusList: this.filterParam.parkStatusList,
        reportType: this.reportType,
        reportStartDate: row.reportDay,
        reportEndDate: '',
        orgId: ''
      };
      if (prods.reportType === '2') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        // @ts-ignore
        console.log(b.slice(-2) - 1, b.slice(-2) - 1, b, '>>>>>>>>>>>');
        // debugger
        if (a === prods.reportStartDate) {
          console.log(a);
          prods.reportStartDate = prods.reportStartDate + '-01';
          prods.reportEndDate =
            // @ts-ignore
            a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;

          console.log(prods.reportStartDate, prods.reportEndDate, '////////////9999999000000');
          // debugger
        }
      }
      if (prods.reportType === '4') {
        let a = moment(new Date()).format('YYYY-MM');
        let b = moment(new Date()).format('YYYY-MM-DD');
        let c = prods.reportStartDate;
        prods.reportStartDate = prods.reportStartDate + '-01-01';
        prods.reportEndDate =
          // @ts-ignore
          a + `-${b.slice(-2) - 1 < 10 ? '0' : ''}${b.slice(-2) - 1 < 10 ? b.slice(-2) - 1 : b.slice(-2) - 1}`;
      }
    }
    this.$router.push({
      name: PARKING_RECORD_LIST,
      params: prods
    });
  }
  channelList = [];
  channelVisible = false;
  // 获取月第一天 最后一天
  getCurrentMonthFirst(time) {
    const date = new Date(time);
    date.setDate(1);
    const y = date.getFullYear(); // 年
    let m: any = date.getMonth() + 1; // 月
    m = m < 10 ? '0' + m : m;
    let d: any = date.getDate(); // 日
    d = d < 10 ? '0' + d : d;
    return y + '-' + m + '-' + d;
  }
  getCurrentMonthLast(time) {
    const date = new Date(time);
    const year = date.getFullYear();
    let month: any = date.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    const day = new Date(year, month, 0);
    return year + '-' + month + '-' + day.getDate();
  }
  async onChannelList(record: any) {
    if (this.channelLoading) return;
    this.channelLoading = true;
    const load: any = this.$message.loading('加载中', 0);
    let execStartTime = '',
      execEndTime = '';
    if (record.reportDay) {
      if (this.reportType == '4') {
        execStartTime = `${record.reportDay}-01-01 00:00:00`;
        execEndTime = `${record.reportDay}-12-31 23:59:59`;
      } else if (this.reportType == '2') {
        execStartTime = this.getCurrentMonthFirst(record.reportDay) + ' 00:00:00';
        execEndTime = this.getCurrentMonthLast(record.reportDay) + ' 23:59:59';
      } else {
        execStartTime = `${record.reportDay} 00:00:00`;
        execEndTime = `${record.reportDay} 23:59:59`;
      }
    }
    const json = {
      execStartTime: execStartTime,
      execEndTime: execEndTime,
      parkId: record.nodeId,
      type: this.reportType
    };
    try {
      const { data, msg } = await queryChannelList(json);
      if (data.length !== 0) {
        this.channelList = Object.freeze(data);
        this.channelVisible = true;
      } else {
        this.channelList = [];
        this.$message.warning('暂无通道识别率的相关数据');
      }
    } catch (e) {
      this.$message.warning((e && e.msg) || '系统异常，请稍后再试');
    } finally {
      load();
      this.channelLoading = false;
    }
  }
  //机动车异常
  async tocarRate(record: any) {
    this.parkName = record.nodeName;
    let execStartTime = '',
      execEndTime = '';
    if (record.reportDay) {
      if (this.reportType == '4') {
        execStartTime = `${record.reportDay}-01-01 00:00:00`;
        execEndTime = `${record.reportDay}-12-31 23:59:59`;
      } else if (this.reportType == '2') {
        execStartTime = this.getCurrentMonthFirst(record.reportDay) + ' 00:00:00';
        execEndTime = this.getCurrentMonthLast(record.reportDay) + ' 23:59:59';
      } else {
        execStartTime = `${record.reportDay} 00:00:00`;
        execEndTime = `${record.reportDay} 23:59:59`;
      }
    }
    let json = {
      parkId: record.nodeId,
      // reportType: this.reportType,
      execStartTime: execStartTime,
      execEndTime: execEndTime
    };
    const load: any = this.$message.loading('加载中', 0);
    try {
      const { data, msg } = await carAbnormalLiftRate(json);
      if (data.length !== 0) {
        this.carAbnormalLiftList = Object.freeze(data);
        this.vehicleVisible = true;
      } else {
        this.carAbnormalLiftList = [];
        this.$message.warning('暂无车场异常抬杆率的相关数据');
      }
    } catch (e) {
      this.$message.warning((e && e.msg) || '系统异常，请稍后再试');
    } finally {
      load();
      this.channelLoading = false;
    }
  }

  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
